import merge from 'lodash/merge.js';

import BaseCourseTemplateForm from '@/store/modules/base/BaseCourseTemplateForm.js';

export default merge(
    BaseCourseTemplateForm({
        type: 'template',
        activityType: 'ActivityTemplates',
        sectionType: 'SectionTemplates',
    }),
    {
        state: {
            pendingCourseTypeIdForCreate: null,
        },
        mutations: {
            setPendingCourseTypeIdForCreate(state, id) {
                state.pendingCourseTypeIdForCreate = id;
            },
            clearPendingCourseTypeIdForCreate(state) {
                state.pendingCourseTypeIdForCreate = null;
            },
        },
    }
);
